function SubmitButton(){
	var me = this;

	me.el = function(){
		return $('button.submit');
	}

	me.submitting = function(ev){
		if(me.el().data('submitting')){
			// alert('double trouble');
			ev.preventDefault();
			return;
		}
		var oldHtml = me.el().html();
		me.el().html('<i class="fa fa-spinner fa-spin"></i> ' + oldHtml).addClass('disabled');
		me.el().width(me.el().width() + 20);
		me.el().data('submitting', true);
	}

	me.observe = function(){
		me.el().click(me.submitting);
	}
	me.observe();
}

$(function(){
	new SubmitButton();
})